export default __webpack_public_path__ + "static/prof-web-home-5237ecd18c61268bd2654b61731cf839.png";